<div class="search-block {{getPromotedSectionAdditionalClasses()}}" [class.open]="isOpen">

  <button class="search-block__close js-close-search" tabindex="0" aria-label="סגירה" (click)="closeSearch()">
    <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.5994 1.39941L1.39941 20.5994M1.39941 1.39941L20.5994 20.5994" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round">
      </path>
    </svg>
  </button>

  <div class="search-block__body">

    <div class="catalog-wrap__top-mob">
      <div class="close-mob-search js-close-search" tabindex="0" role="button" aria-label="סגירה"
        (click)="closeSearchMobilePopup()">
        <img src="Content/Images/icons/arrow-mob.svg" width="10" height="18">
      </div>
      <!-- <h3 class="title title--mid title--dark">{{searchData.headerSearchTitle}}</h3>
      <br>
      <br> -->
    </div>
    <h3 class="title title--dark title--middle">{{searchData.headerSearchTitle}}</h3>
    <!-- <br>
    <br> -->
    <app-preloader *ngIf="isLoading" [miniPreloader]="true" [incomingText]="searchData.redirectingText">
    </app-preloader>

    <div class="search-block__form" *ngIf="!isLoading">
      <div *ngIf="!isMobile" class="form-wrapper search-field" #searchForm>
        <form class="search-form loading" (ngSubmit)="onSearchInputSubmit($event)" role="search">
          <div class="search-form__body">
            <div class="input-field">
              <input [formControl]="searchInputControl" 
                #searchInput type="search" 
                (input)="onSearchInputChange($event)"
                [placeholder]="searchData.headerSearchPlaceholder" 
                [matAutocomplete]="option"
                [matAutocompletePosition]="'below'"
              />
              <div class="actions">
                <button class="clear" type="button" *ngIf="searchQuery !== ''" (click)="clearInput()">
                  <span>×</span>
                </button>
                <button class="submit" type="submit">
                  <span class="catalog-search-btn">
                    <svg width="40" height="20" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M2.3501 8.43711C2.3501 4.79893 5.29942 1.84961 8.9376 1.84961C12.5758 1.84961 15.5251 4.79893 15.5251 8.43711C15.5251 12.0753 12.5758 15.0246 8.9376 15.0246C5.29942 15.0246 2.3501 12.0753 2.3501 8.43711ZM8.9376 0.849609C4.74714 0.849609 1.3501 4.24665 1.3501 8.43711C1.3501 12.6276 4.74714 16.0246 8.9376 16.0246C10.8529 16.0246 12.6024 15.315 13.9376 14.1442L17.359 17.5657C17.5543 17.7609 17.8709 17.7609 18.0662 17.5657C18.2614 17.3704 18.2614 17.0538 18.0662 16.8586L14.6447 13.4371C15.8154 12.1019 16.5251 10.3524 16.5251 8.43711C16.5251 4.24665 13.1281 0.849609 8.9376 0.849609Z">
                      </path>
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
          <mat-autocomplete 
            #option="matAutocomplete" 
            (optionSelected)="onAutocompleteSelect($event.option.value)"
            class="catalog-autocomplete-panel"
          >
            <span *ngIf="groupOptions">
              <mat-optgroup *ngFor="let group of groupOptions" [label]="group.groupName">
                <mat-option *ngFor="let option of group.options" [value]="option">
                  <div class="option">
                    {{ option.key }}
                  </div>
                </mat-option>
              </mat-optgroup>
            </span>
          </mat-autocomplete>
        </form>
      </div>

      <div *ngIf="isMobile" class="form-wrapper search-field" #searchForm>
        <form class="search-form catalog-mobile-search-form" (ngSubmit)="onSearchInputSubmit($event)" role="search">
          <div class="search-form__body">
            <div class="input-field">
              <input [formControl]="searchInputControl" 
                #searchInput type="search" 
                (input)="onSearchInputChange($event)"
                [placeholder]="searchData.headerSearchPlaceholder" 
                [matAutocomplete]="option"
                [matAutocompletePosition]="'below'" 
              />
              <div class="actions">
                <button class="clear" type="button" *ngIf="searchQuery !== ''" (click)="clearInput()">
                  <span>×</span>
                </button>
                <button class="submit" type="submit">
                  <span class="catalog-search-btn">
                    <svg width="40" height="20" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M2.3501 8.43711C2.3501 4.79893 5.29942 1.84961 8.9376 1.84961C12.5758 1.84961 15.5251 4.79893 15.5251 8.43711C15.5251 12.0753 12.5758 15.0246 8.9376 15.0246C5.29942 15.0246 2.3501 12.0753 2.3501 8.43711ZM8.9376 0.849609C4.74714 0.849609 1.3501 4.24665 1.3501 8.43711C1.3501 12.6276 4.74714 16.0246 8.9376 16.0246C10.8529 16.0246 12.6024 15.315 13.9376 14.1442L17.359 17.5657C17.5543 17.7609 17.8709 17.7609 18.0662 17.5657C18.2614 17.3704 18.2614 17.0538 18.0662 16.8586L14.6447 13.4371C15.8154 12.1019 16.5251 10.3524 16.5251 8.43711C16.5251 4.24665 13.1281 0.849609 8.9376 0.849609Z">
                      </path>
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
          <mat-autocomplete #option="matAutocomplete" 
            (optionSelected)="onAutocompleteSelect($event.option.value)"
            class="catalog-autocomplete-panel"
          >
            <span *ngIf="groupOptions">
              <mat-optgroup *ngFor="let group of groupOptions" [label]="group.groupName">
                <mat-option *ngFor="let option of group.options" [value]="option">
                  <div class="option">{{ option.key }}</div>
                </mat-option>
              </mat-optgroup>
            </span>
          </mat-autocomplete>
        </form>
      </div>

    </div>

  </div>